/**
 * Sidstorleksväljaren i listningar. Navigerar om vid ändring.
 *
 * Ersätter FrontendSrc/patternlab/js/pagination.js.
 */
export function initPagination(): void {
    document.querySelectorAll<HTMLSelectElement>('.js-page-size').forEach(select => {
        select.addEventListener('change', () => {
            const url = select.dataset.url;
            if (!url) return;
            // Behåll originalets beteende: url:en innehåller redan en query-sträng.
            window.location.href = `${url}&pageSize=${encodeURIComponent(select.value)}`;
        });
    });
}
